import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
      priceFormatter,
    linkFormatter,
    customFormatter,
    dateFormatter,
    getFieldByPathFormatter
} from 'util/Utils';
import formatNumbers  from 'util/formatNumbers';
import config from  '../../../config';

class SellerTransactionsTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {

        };
    }


    payoutFormatter(cell, row){
         if (row.Type == 'Credit' ){
                return  '+' + formatNumbers.formatMoney(row.Amount);
            }else if (row.Type == 'Fee' || row.Type == 'PickupFee'){
                return  '-' + formatNumbers.formatMoney(row.Amount);
            }
        }

    render() {
        return (
            <div className=" databases-table top20">
                <BootstrapTable data={this.props.sellerTransactions} ref='table'
                                remote={ true }
                                hover={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }
                >
                    <TableHeaderColumn width="50px" dataField='Description' dataAlign="center"
                                       dataSort={true}>Description</TableHeaderColumn>
                    <TableHeaderColumn   dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="30px"   dataAlign="center"    dataField='Type'  dataFormat={ customFormatter }
                                       dataSort={true}    formatExtraData={ {path:[  'Type']  , format: (value)=>{ return _.startCase(value) }}}  >Type</TableHeaderColumn>

                    <TableHeaderColumn width="30px"   dataAlign="center" dataFormat={ this.payoutFormatter.bind(this) }>Payout</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataFormat={ customFormatter }
                                       formatExtraData={ {path:[  'Status']  , format: (value)=>{return _.startCase(value) }}}
                                       dataField='Status' dataAlign="center"
                                       dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataField='FulfilledAt'  dataAlign="center" dataFormat={ dateFormatter }
                                       formatExtraData={ {'name': 'FulfilledAt', 'format': 'MM/DD/YY'} }
                                       dataSort={true}  >Date Fulfilled</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default SellerTransactionsTable;
